import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, Paper, Typography, Box, Divider } from '@material-ui/core'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import LinearProgress from '@material-ui/core/LinearProgress'
import StarRateIcon from '@material-ui/icons/StarRate';

import { SUBSCRIBER_TMDB_RATING } from '../../constants/module_info'
import { CATALOG_NETWORK_DEFAULT1, CATALOG_NETWORK_DEFAULT2, CATALOG_NETWORK_PRIMARY } from '../../constants/colors'

const BorderLinearProgressPrimary = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 0,
    backgroundColor: CATALOG_NETWORK_PRIMARY
  }
}))(LinearProgress)

const BorderLinearProgressDefault1 = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 0,
    backgroundColor: CATALOG_NETWORK_DEFAULT1
  }
}))(LinearProgress)
const BorderLinearProgressDefault2 = withStyles((theme) => ({
  root: {
    height: 16,
    borderRadius: 0
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700]
  },
  bar: {
    borderRadius: 0,
    backgroundColor: CATALOG_NETWORK_DEFAULT2
  }
}))(LinearProgress)

export class SubscriberRatingComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    primaryNetwork: PropTypes.object,
    defaultNetwork1: PropTypes.object,
    defaultNetwork2: PropTypes.object,
    subscriber: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      primaryNetworkAverageRating: null,
      defaultNetwork1AverageRating: null,
      defaultNetwork2AverageRating: null
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.subscriber.details &&
      (prevProps.primaryNetwork !== this.props.primaryNetwork && this.props.primaryNetwork) ||
      (prevProps.defaultNetwork1 !== this.props.defaultNetwork1 && this.props.defaultNetwork1) ||
      (prevProps.defaultNetwork2 !== this.props.defaultNetwork2 && this.props.defaultNetwork2)) {
      const averageTMDBRating = this.props.subscriber.details.average_tmdbrating
      this.setState({
        primaryNetworkAverageRating: averageTMDBRating.filter(n => n.data.data.network === this.props.primaryNetwork.network)[0],
        defaultNetwork1AverageRating: averageTMDBRating.filter(n => n.data.data.network === this.props.defaultNetwork1.network)[0],
        defaultNetwork2AverageRating: averageTMDBRating.filter(n => n.data.data.network === this.props.defaultNetwork2.network)[0]
      })
    }
  }

  getPercentage = (count) => {
    return ((count / 10) * 100).toFixed(1) / 1
  }
  getRating = (rating) => {
    return rating.toFixed(1) / 1
  }

  render () {
    const { classes } = this. props
    const { primaryNetworkAverageRating, defaultNetwork1AverageRating, defaultNetwork2AverageRating } = this.state
    return (
      <Paper className={`metricBox ${classes.paper}`}>
        <Grid container spacing={1} direction="column">
          <Grid item className='cardPadding p-b-0'>
            <span className={`metricTitle ${classes.cardTitle}`}>Average TMDB Rating per Title</span>
            <OverlayTrigger overlay={<Tooltip id="tooltip">{SUBSCRIBER_TMDB_RATING}</Tooltip>} placement="right">
              <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
            </OverlayTrigger>
          </Grid>
          <Grid item className={`metric-sub ${classes.cardSubTitle}`}>The average user rating across new content released YTD</Grid>
        </Grid>
        { primaryNetworkAverageRating &&
          <Box className="boxStart primary primaryIcon">
            <Box className="d-flex align-items-center">
              <Box className="w-25">
                <Typography className="metricProLabel">{primaryNetworkAverageRating.data.data.network}</Typography>
              </Box>
              <Box className="w-55 progressRotate">
                <BorderLinearProgressPrimary variant="determinate" value={this.getPercentage(primaryNetworkAverageRating.data.data.count)} />
              </Box>
              <Box className="w-25 text-right">
                <Typography className="metricProLabel">{this.getRating(primaryNetworkAverageRating.data.data.count)} <StarRateIcon style={{ fontSize: 38, height: 'auto' }}/></Typography>
              </Box>
            </Box>
            <Divider className="progressDivide"/>
          </Box>
        }
        { defaultNetwork1AverageRating &&
          <Box className="defaultOne defaultOneIcon">
            <Box className="d-flex align-items-center">
              <Box className="w-25">
                <Typography className="metricProLabel">{defaultNetwork1AverageRating.data.data.network}</Typography>
              </Box>
              <Box className="w-55 progressRotate">
                <BorderLinearProgressDefault1 variant="determinate" value={this.getPercentage(defaultNetwork1AverageRating.data.data.count)} />
              </Box>
              <Box className="w-25 text-right">
                <Typography className="metricProLabel">{this.getRating(defaultNetwork1AverageRating.data.data.count)} <StarRateIcon style={{ fontSize: 38, height: 'auto' }}/></Typography>
              </Box>
            </Box>
            <Divider className="progressDivide"/>
          </Box>
        }
        { defaultNetwork2AverageRating &&
          <Box className="defaultTwo mb-3 defaultTwoIcon">
            <Box className="d-flex align-items-center">
              <Box className="w-25">
                <Typography className="metricProLabel">{defaultNetwork2AverageRating.data.data.network}</Typography>
              </Box>
              <Box className="w-55 progressRotate">
                <BorderLinearProgressDefault2 variant="determinate" value={this.getPercentage(defaultNetwork2AverageRating.data.data.count)} />
              </Box>
              <Box className="w-25 text-right">
                <Typography className="metricProLabel">{this.getRating(defaultNetwork2AverageRating.data.data.count)} <StarRateIcon style={{ fontSize: 38, height: 'auto' }}/></Typography>
              </Box>
            </Box>
          </Box>
        }
      </Paper>
    )
  }
}

export default withStyles(styles)(SubscriberRatingComponent)
